module.exports = __webpack_public_path__ + "staticcomp/img/top.b5d18c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/4/top.jpg
// module id = tmu7
// module chunks = 39